import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AddonRow from './AddonRow.tsx';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';

const FoodItemRow = ({ foodItem }: any) => {
    const [open, setOpen] = React.useState(false);

    const GetFoodItemSubTotal = (item) => {
        var total = item.basePrice * item.initialQty;

        var addonTotal = Array.isArray(item.addons) && item.addons.length > 0
            ? item.addons.reduce((accumulator, addon) => {
                let addonSubTotal = (addon.basePrice || 0) * (addon.qty) ;

                if (Array.isArray(addon.options) && addon.options.length > 0) {
                    addon.options.forEach(option => {
                        addonSubTotal += (option.basePrice || 0) * (option.qty || 0);
                        
                        if (Array.isArray(option.subOptions) && option.subOptions.length > 0) {
                            option.subOptions.forEach(subOption => {
                                addonSubTotal += (subOption.basePrice || 0) * (subOption.subOptionQuantity || 0);
                            });
                        }
                    });
                }
                return accumulator + addonSubTotal;
            }, 0) : 0;

        return (total + addonTotal).toFixed(2);
    }
    console.log("fgfgf",foodItem)
    return (
        <>
            <TableRow>
                <TableCell align="left">
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell sx={{ textWrap: 'nowrap' }} align="left">{foodItem.orderItemName}</TableCell>
                <TableCell align="center" className='fooditem-refund-status'>
                    <span style={{ color: 'rgba(220, 53, 69, 1)', fontStyle: 'italic', fontWeight: 'bold', fontSize: '12px'}}>
                        {foodItem.refundStatus !== "" ? foodItem.refundStatus : "N/A"}
                    </span>
                </TableCell>
                <TableCell align="center">£ {foodItem.basePrice}</TableCell>
                <TableCell align="center">£ {(foodItem?.sdInAmount * foodItem?.qty)?.toFixed(2)}</TableCell>
                <TableCell align="center">£ {(foodItem?.vatInAmount * foodItem?.qty)?.toFixed(2)}</TableCell>
                <TableCell align="center">{foodItem.qty}</TableCell>
                <TableCell align="center">£ {foodItem.tips}</TableCell>
                <TableCell align="center">£ {foodItem.serviceCharge}</TableCell>
                <TableCell align="center">£ {foodItem.serviceChargeVat}</TableCell>
                <TableCell align="center">£ {foodItem.totalCredit}</TableCell>
                <TableCell align="center">£ {GetFoodItemSubTotal(foodItem)}</TableCell>
                <TableCell align="center">£ {foodItem?.totalPrice?.toFixed(2)}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: "120%" }}>
                        {foodItem?.addons?.length > 0 ?
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    Add ons
                                </Typography>
                                <Table size="small" aria-label="food-items">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell align='left'>Addon Name</TableCell>
                                            <TableCell align="center">VAT Per Addon</TableCell>
                                            <TableCell align="center">SD Per Addon</TableCell>
                                            <TableCell align="center">Addon Quantity</TableCell>
                                            <TableCell align="center">Addon Base Price</TableCell>
                                            <TableCell align="center" style={{ textWrap: 'nowrap' }}>Addon Sub Total</TableCell>
                                            <TableCell align="center" style={{ textWrap: 'nowrap' }}>Addon Total Price</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {open && foodItem.addons.map((addon, index) => (
                                            <AddonRow key={index} addon={addon} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                            : ""
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default FoodItemRow;